const { Component } = Shopware;

Component.register('topdata-es-llm-notice', {
    template: `
        <sw-alert
            v-if="!llmProviderAvailable"
            variant="warning"
            :showIcon="true"
            :closable="false"
        >
            {{ $tc('TopdataEnhancedSearchSW6.config.llmProviderMissing') }}
        </sw-alert>
    `,

    data() {
        return {
            llmProviderAvailable: true,
        };
    },

    created() {
        Shopware.Application.getContainer('init').httpClient.get('/_action/topdata-enhanced-search-sw6/feature-availability')
            .then((response) => {
                this.llmProviderAvailable = !!response.data.llmProviderAvailable;
            })
            .catch(() => {
                this.llmProviderAvailable = false;
            });
    },
});
